import "./i18n";
import { useEffect, useState } from "react";
import { supabase } from "./supabaseClient";

import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AuthProvider, useAuth } from "./context/AuthProvider";

import Register from "./pages/Register";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import QuestionnairePage from "./pages/QuestionnairePage";
import CareerPreferences from "./pages/CareerPreferences";
import DashboardRightPanel from "./components/DashboardRightPanel";
import QuestionnaireWizard from "./pages/QuestionnaireWizard";
import QuestionnaireStep1 from "./components/QuestionnaireStep1";
import CareerPreferencesStep2 from "./components/CareerPreferencesStep2";
import ConsentStep3 from "./components/ConsentStep3";
import CustomDropdown from "./components/CustomDropdown";
import AuthCallback from "./pages/AuthCallback";
import QuizPage from "./pages/QuizPage";
import PremiumOffer from "./pages/PremiumOffer";
import PremiumSuccess from "./pages/PremiumSuccess";
import ResumeBuilder from "./pages/ResumeBuilder";
import ResumeImport from "./pages/ResumeImport";
import ChoosePlan from "./pages/ChoosePlan";
import StripeReturn from "./pages/StripeReturn";
import InstructionsPage from "./pages/InstructionsPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import FoundationTruth from "./pages/FoundationTruth";
import PrivacyandCookiePolicy from "./pages/PrivacyandCookiePolicy";
import TermsandConditions from "./pages/TermsandConditions";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ContactPage from "./pages/Contact";
import PlanProtectedRoute from "./pages/PlanProtectedRoute";
import RunwayCalculator from "./pages/RunwayCalculator";

// NEW SEO PAGES
import SnapshotPage from "./pages/SnapshotPage";
import DeepAuditPage from "./pages/DeepAuditPage";

import FAQPage from "./pages/FAQPage";

import FinancialRunwayCalculatorFAQ from "./pages/FinancialRunwayCalculatorFAQ";

import ProtectedRoute from "./components/ProtectedRoute";

import AdminLogin from "./pages/AdminLogin";
import AdminPremiumList from "./pages/AdminPremiumList";
import AdminProtectedRoute from "./components/AdminProtectedRoute";

import { CookieConsentProvider } from "./context/CookieConsentProvider";
import CookieConsentBanner from "./components/consent/CookieConsentBanner";

import { HelmetProvider } from "react-helmet-async";

import CalculatorInstructionsPage from "./pages/CalculatorInstructionsPage";

import BlogPage from "./pages/BlogPage";
import BlogDetailPage from "./pages/BlogDetailPage";

import SubmitArticlePage from "./pages/SubmitArticlePage";

import AboutPage from "./pages/AboutPage";
import MethodologyPage from "./pages/MethodologyPage";
import DataSourcesPage from "./pages/DataSourcesPage";
import EditorialPolicyPage from "./pages/EditorialPolicyPage";
import DisclaimerPage from "./pages/DisclaimerPage";

import CareerResilienceAudit
  from "./pages/CareerResilienceAudit";
import ScrollToTop from "./components/ScrollToTop";




// Force canonical host so Supabase session storage is consistent
(function forceCanonicalHost() {
  const CANONICAL_HOST = "www.reignitespirit.com";
  const { protocol, hostname, pathname, search, hash } = window.location;

  if (hostname === "reignitespirit.com") {
    window.location.replace(`${protocol}//${CANONICAL_HOST}${pathname}${search}${hash}`);
  }
})();

function InstructionsRedirect() {
  const [checking, setChecking] = useState(true);
  const [goCalculator, setGoCalculator] = useState(false);

  const normalizePlan = (p) => {
    const v = (p || "").toString().trim().toLowerCase();

    if (!v) return "";
    if (v === "free_calculator" || v.includes("calculator") || v.includes("free")) {
      return "free_calculator";
    }
    if (v.includes("deep")) return "deep_audit";
    if (v.includes("snap")) return "snapshot";

    return "";
  };

  useEffect(() => {
    const checkUserPlan = async () => {
      const localPlan = normalizePlan(
        localStorage.getItem("selectedPlan") ||
          sessionStorage.getItem("user_plan")
      );

      if (localPlan === "free_calculator") {
        setGoCalculator(true);
        setChecking(false);
        return;
      }

      const { data } = await supabase.auth.getSession();
      const authUid = data?.session?.user?.id;

      if (!authUid) {
        setChecking(false);
        return;
      }

      const { data: dbUser } = await supabase
        .from("users")
        .select("plan, source")
        .eq("auth_uid", authUid)
        .maybeSingle();

      const dbPlan = normalizePlan(dbUser?.plan);
      const dbSource = (dbUser?.source || "").toLowerCase();

      if (dbPlan === "free_calculator" || dbSource === "financial_calculator") {
        localStorage.setItem("selectedPlan", "free_calculator");
        sessionStorage.setItem("user_plan", "free_calculator");
        setGoCalculator(true);
      }

      setChecking(false);
    };

    checkUserPlan();
  }, []);

  if (checking) {
    return (
      <div className="min-h-screen bg-[#020617] text-white flex items-center justify-center">
        Checking your registration type...
      </div>
    );
  }

  if (goCalculator) {
    return <Navigate to="/calculator-instructions" replace />;
  }

  return <InstructionsPage />;
}
function AppRoutes() {
  const { session } = useAuth();
  const { i18n } = useTranslation();

  const clearLegacyGlobalAssessmentKeys = () => {
    localStorage.removeItem("current_assessment_id");
    localStorage.removeItem("payment_assessment_id");
  };

  useEffect(() => {
    clearLegacyGlobalAssessmentKeys();
  }, []);

  useEffect(() => {
    const lang = localStorage.getItem("lang") || "en";
    i18n.changeLanguage(lang);
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = lang;
  }, [i18n]);

  return (
    <Routes>
      {/* ================= PUBLIC SEO PAGES ================= */}
      <Route path="/landing" element={<ChoosePlan />} />
      <Route path="/snapshot" element={<SnapshotPage />} />
      <Route path="/deep-audit" element={<DeepAuditPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/blog" element={<BlogPage />} />
<Route path="/blog/:slug" element={<BlogDetailPage />} />

<Route path="/submit-article" element={<SubmitArticlePage />} />

  <Route
  path="/financial-runway-calculator-faq"
  element={<FinancialRunwayCalculatorFAQ />}
/>
<Route
  path="/career-resilience-audit"
  element={<CareerResilienceAudit />}
/>
<Route path="/contact" element={<ContactPage />} />
<Route
  path="/Financial_Runway_Calculator_FAQ"
  element={
    <Navigate
      to="/financial-runway-calculator-faq"
      replace
    />
    
  }
/>

      {/* Root redirect */}
      <Route
        path="/"
        element={session ? <Navigate to="/dashboard" replace /> : <Navigate to="/landing" replace />}
      />

      {/* Avoid duplicate URL */}
      <Route path="/choose-plan" element={<Navigate to="/landing" replace />} />

      {/* ================= AUTH / PUBLIC ================= */}
      <Route
        path="/register"
        element={
          <PlanProtectedRoute>
            <Register />
          </PlanProtectedRoute>
        }
      />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/stripe-return" element={<StripeReturn />} />
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="/foundation-truth" element={<FoundationTruth />} />
      <Route path="/privacy-cookie" element={<PrivacyandCookiePolicy />} />
      <Route path="/terms-conditions" element={<TermsandConditions />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      <Route path="/about" element={<AboutPage />} />

<Route
  path="/methodology"
  element={<MethodologyPage />}
/>

<Route
  path="/data-sources"
  element={<DataSourcesPage />}
/>

<Route
  path="/editorial-policy"
  element={<EditorialPolicyPage />}
/>

<Route
  path="/disclaimer"
  element={<DisclaimerPage />}
/>

      {/* ================= PROTECTED ================= */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
  path="/questionnaire"
  element={
    <ProtectedRoute>
      <QuestionnairePage />
    </ProtectedRoute>
  }
/>
      <Route
        path="/careerpreferences"
        element={
          <ProtectedRoute>
            <CareerPreferences />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboardrightpanel"
        element={
          <ProtectedRoute>
            <DashboardRightPanel />
          </ProtectedRoute>
        }
      />
      <Route
        path="/questionnairewizard"
        element={
          <ProtectedRoute>
            <QuestionnaireWizard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/questionnairestep1"
        element={
          <ProtectedRoute>
            <QuestionnaireStep1 />
          </ProtectedRoute>
        }
      />
      <Route
        path="/careerpreferencesstep2"
        element={
          <ProtectedRoute>
            <CareerPreferencesStep2 />
          </ProtectedRoute>
        }
      />
      <Route
        path="/consentstep3"
        element={
          <ProtectedRoute>
            <ConsentStep3 />
          </ProtectedRoute>
        }
      />
      <Route
        path="/customdropdown"
        element={
          <ProtectedRoute>
            <CustomDropdown />
          </ProtectedRoute>
        }
      />
      <Route
        path="/quiz"
        element={
          <ProtectedRoute>
            <QuizPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/premiumoffer"
        element={
          <ProtectedRoute>
            <PremiumOffer />
          </ProtectedRoute>
        }
      />
      <Route
        path="/premium-success"
        element={
          <ProtectedRoute>
            <PremiumSuccess />
          </ProtectedRoute>
        }
      />
      <Route
        path="/resume-builder"
        element={
          <ProtectedRoute>
            <ResumeBuilder />
          </ProtectedRoute>
        }
      />
      <Route
        path="/resume-import"
        element={
          <ProtectedRoute>
            <ResumeImport />
          </ProtectedRoute>
        }
      />
      <Route
  path="/instructions"
  element={
    <ProtectedRoute>
      <InstructionsRedirect />
    </ProtectedRoute>
  }
/>
      <Route
  path="/calculator-instructions"
  element={<ProtectedRoute><CalculatorInstructionsPage /></ProtectedRoute>}
/>
      {/* <Route
        path="/contact"
        element={
          <ProtectedRoute>
            <ContactPage />
          </ProtectedRoute>
        }
      /> */}
      <Route path="/runway-calculator" element={<RunwayCalculator />} />
{/* <Route
  path="/career-resilience-audit"
  element={
    <ProtectedRoute>
      <CareerResilienceAudit />
    </ProtectedRoute>
  }
/> */}
      {/* ================= ADMIN ================= */}
      <Route path="/admin-login" element={<AdminLogin />} />
      <Route
        path="/adminpremiumlist"
        element={
          <AdminProtectedRoute>
            <AdminPremiumList />
          </AdminProtectedRoute>
        }
      />

      {/* ================= FALLBACK ================= */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
export default function App() {
  return (
    <HelmetProvider>
      <CookieConsentProvider>
        <AuthProvider>
          <Router>

            {/* GLOBAL SCROLL-TO-TOP FOR EVERY ROUTE */}
            <ScrollToTop />

            <CookieConsentBanner />

            <AppRoutes />

          </Router>
        </AuthProvider>
      </CookieConsentProvider>
    </HelmetProvider>
  );
}